import { render, staticRenderFns } from "./facet.vue?vue&type=template&id=dd02abdc&"
import script from "./facet.vue?vue&type=script&lang=js&"
export * from "./facet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports